import React from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import GroupCheckbox from '../../common/GroupCheckbox/GroupCheckbox.js'

import moment from 'moment'
moment.tz = require('moment-timezone')

class TimeSlotMain extends React.Component {
  state = {
    isLoading: false,

    serviceType: '',
    action: 'create',
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().add(1, 'day').format('YYYY-MM-DD'),

    selected_ids: [],
    categoryList: [],
    list: [],
  }

  componentDidMount() {
    this.loadData()
  }

  loadData = async () => {
    let categoryList = await axios.get(Constant.getAPI() + '/cruise/list-cruise-masters', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (
      categoryList.status == 200 &&
      categoryList.data &&
      categoryList.data.data &&
      categoryList.data.data.length > 0
    ) {
      this.setState(
        {
          categoryList: categoryList.data.data.filter(
            (item) => item.is_active == true && item.category_type == 'CRUISE'
          ),
        },
        () => {
          this.state.categoryList.forEach(async (category) => {
            if (category.category_type == 'CRUISE') {
              let list = await axios.get(Constant.getAPI() + '/cruise/get-cruise-listing/' + category.id, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                  country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
              })

              if (list.status == 200 && list.data && list.data.data && list.data.data.length > 0) {
                this.setState({
                  list: {
                    ...this.state.list,
                    [category.id]: list.data.data.map((item) => ({
                      id: item.id,
                      name:
                        item.cruise_name_en +
                        (item.slot_from && item.slot_to
                          ? ` (${item.slot_from.substring(0, 5)} - ${item.slot_to.substring(0, 5)})`
                          : ''),
                    })),
                  },
                })
              }
            }
          })
        }
      )
    }

    let chaletListData = await axios.get(Constant.getAPI() + '/chalet/list-chalet', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (
      chaletListData.status == 200 &&
      chaletListData.data &&
      chaletListData.data.data &&
      chaletListData.data.data.length > 0
    ) {
      this.setState({
        list: {
          ...this.state.list,
          chalet: chaletListData.data.data
            .filter((itm) => itm.is_active)
            .map((itm) => ({
              id: itm.id,
              name: itm.name_en,
            })),
        },
      })
    }
  }

  handleChange = (event, name) => {
    if (name == 'selected_items') {
      this.setState({ selected_ids: event })
    } else {
      this.setState({ [event.target.name]: event.target.value })

      if (event.target.name == 'action' || event.target.name == 'serviceType') {
        this.setState({ selected_ids: [] })
      }
    }
  }

  onSave = () => {
    this.setState({ isLoading: true })

    axios
      .post(
        Constant.getAPI() + '/admin/time-slots-bulk-action',
        {
          action: this.state.action,
          service_type: this.state.serviceType == 'chalet' ? 'chalet' : 'cruise',
          start_date: this.state.start_date,
          end_date: this.state.end_date,
          selected_ids: this.state.selected_ids,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((result) => {
        this.setState({
          isLoading: false,
          serviceType: '',
          action: 'create',
          start_date: moment().format('YYYY-MM-DD'),
          end_date: moment().add(1, 'day').format('YYYY-MM-DD'),

          selected_ids: [],
        })
        if (result.status === 200) {
          Swal.fire('Updated !', ``, 'success')
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Time Slots Master</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Time Slots Master</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-6">
                          <div className="form-group row">
                            <label className="col-md-4 col-form-label">Select Action Type</label>
                            <div className="col-md-8">
                              <select
                                name="action"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.action}
                              >
                                <option value="create">Create Slots</option>
                                <option value="block">Block Slots</option>
                                <option value="unblock">Unblock Slots</option>
                                {/* <option value="view">View Slots</option> */}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className="form-group row">
                            <label className="col-md-4 col-form-label">Select Service Type</label>
                            <div className="col-md-8">
                              <select
                                name="serviceType"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.serviceType}
                              >
                                <option value="">Select Type</option>
                                {this.state.categoryList.map((item) => (
                                  <option
                                    value={item.id}
                                    key={item.id}
                                  >
                                    {item.cruise_cat_en}
                                  </option>
                                ))}
                                <option value="chalet">Chalet</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Start Date</label>
                            <div className="col-sm-8">
                              <input
                                type="date"
                                min={moment().format('YYYY-MM-DD')}
                                id="start_date"
                                name="start_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.start_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">End Date</label>
                            <div className="col-sm-8">
                              <input
                                type="date"
                                min={moment().format('YYYY-MM-DD')}
                                max={moment(this.state.start_date, 'YYYY-MM-DD').add(180, 'day').format('YYYY-MM-DD')}
                                id="end_date"
                                name="end_date"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.end_date}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-12 border"></div>
                        <div className="col-12 m-t-20">
                          <GroupCheckbox
                            title={'Select Items'}
                            list={this.state.list[this.state.serviceType] || []}
                            displayKey={'name'}
                            idKey={'id'}
                            selected={this.state.selected_ids}
                            onChange={(event) => this.handleChange(event, 'selected_items')}
                          ></GroupCheckbox>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-6">
                          {
                            <span style={{ fontWeight: 'bold', color: 'red' }}>
                              #1. You can create 6 month's Time slots at a time
                            </span>
                          }
                          <br />
                          {this.state.action == 'create' && this.state.serviceType != 'chalet' && (
                            <span
                              style={{
                                fontWeight: 'bold',
                                color: 'red',
                              }}
                            >
                              #2. If any cruise have not any privious slot in system then slots will be created from
                              00:00 to 23:00
                            </span>
                          )}
                        </div>
                        <div className="col-6 text-right">
                          {this.state.isLoading ? (
                            <button className="btn btn-grd-disabled mr-2">Saving...!</button>
                          ) : (
                            <button
                              onClick={this.onSave}
                              className="btn btn-grd-disabled mr-2"
                            >
                              <i className="icofont icofont-save"></i>Save
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TimeSlotMain
